import React, { FC } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'reactstrap';
import SimplePage from '../Layout/Pages/SimplePage';

const SessionEnded: FC = () => {
  // Standalone, inert page. Must not call logOutAndCleanUp or broadcast
  // anything itself: it is the destination other tabs land on after a
  // logout broadcast, and any further broadcast from here would re-enter
  // the cross-tab cycle.
  const { formatMessage } = useIntl();

  return (
    <SimplePage
      title={formatMessage({
        id: 'app.views.session.session_ended.title',
        defaultMessage: "You've been signed out",
      })}
    >
      <p>
        <FormattedMessage
          id="app.views.session.session_ended.body"
          defaultMessage="You signed out in another tab or window. Sign in again to continue where you left off."
        />
      </p>
      <div className="mb-4">
        <Button color="primary" onClick={() => window.location.assign('/')}>
          <FormattedMessage
            id="app.views.session.session_ended.sign_in"
            defaultMessage="Sign in"
          />
        </Button>
      </div>
    </SimplePage>
  );
};

export default React.memo(SessionEnded);
